import Auth0NavigationProvider from 'contexts/Auth0NavigationProvider/index.jsx';
import ProfessionalProfileProvider from 'contexts/ProfessionalProfileProvider/index.jsx';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'styles/global.scss';
import 'styles/main.scss';
import { App } from './App.jsx';
import './index.css';

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <BrowserRouter>
            <Auth0NavigationProvider>
                <ProfessionalProfileProvider>
                    <App />
                </ProfessionalProfileProvider>
            </Auth0NavigationProvider>
        </BrowserRouter>
    </StrictMode>
);
